import { render, staticRenderFns } from "./typesRoomMainPage.vue?vue&type=template&id=0a22a2ca&scoped=true&"
import script from "./typesRoomMainPage.vue?vue&type=script&lang=js&"
export * from "./typesRoomMainPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a22a2ca",
  null
  
)

export default component.exports